export const GROUP_NAME = 'autocomplete'
